import { Component, Inject, Input, OnInit } from '@angular/core';
import { AWSTranslateJSON } from '@app/utils/translation';
import _ from 'lodash';
import config from '@config/index';
@Component({
  selector: 'app-landing-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
})
export class LandingActivityComponent implements OnInit {
  @Input() stream: any;
  @Input() name: string;
  translateJSON: AWSTranslateJSON;
  constructor() {}

  ngOnInit() {
    this.translateJSON = new AWSTranslateJSON({
      accessKeyId: config.awsAccessKeyId,
      secretAccessKey: config.awsSecretAccessKey,
      region: config.awsRegion,
    });
  }
}
